var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 138,
    viewBox: "0 0 218 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M217.992 123.562H0.00976562V124.822H217.992V123.562Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M166.135 59.8086H163.762V85.5417H166.135V59.8086Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M195.735 59.8086H193.361V85.5417H195.735V59.8086Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M197.05 74.9152H162.478C159.432 74.9152 156.994 72.4507 156.994 69.4421V46.2055C156.994 40.6684 161.484 36.1875 167.032 36.1875H192.528C198.076 36.1875 202.566 40.6684 202.566 46.2055V69.4421C202.534 72.4507 200.065 74.9152 197.05 74.9152Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M203.816 123.885H206.125L201.218 81.3164H198.941L203.816 123.885Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M155.679 123.885H153.402L158.277 81.3164H160.586L155.679 123.885Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M157.925 72.6758H156.129V83.622H157.925V72.6758Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M160.778 73.154H153.178C151.831 73.154 150.74 72.0658 150.74 70.7215C150.74 69.3773 151.831 68.2891 153.178 68.2891H160.778C162.125 68.2891 163.216 69.3773 163.216 70.7215C163.216 72.0658 162.125 73.154 160.778 73.154Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M203.464 72.6758H201.668V83.622H203.464V72.6758Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M206.317 73.154H198.717C197.37 73.154 196.279 72.0658 196.279 70.7215C196.279 69.3773 197.37 68.2891 198.717 68.2891H206.317C207.664 68.2891 208.755 69.3773 208.755 70.7215C208.755 72.0658 207.664 73.154 206.317 73.154Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M206.126 90.3408H153.402V87.6523C153.402 83.7155 156.577 80.5469 160.522 80.5469H199.006C202.951 80.5469 206.126 83.7155 206.126 87.6523V90.3408Z",
    fill: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    d: "M183.164 2.93123C183.164 2.93123 181.657 0.434738 179.283 0.178687C176.91 -0.0773635 171.747 1.779 169.342 9.84461C166.936 17.9102 172.452 28.3443 172.452 28.3443C174.537 28.2483 176.654 28.1523 178.738 28.0242C180.31 27.9602 181.913 27.8642 183.485 27.8002C184.126 27.7682 184.8 27.7682 185.441 27.7042C186.082 27.6402 186.916 28.0562 187.493 27.9282C187.718 27.8642 187.878 27.6722 188.039 27.4481C190.412 24.1195 191.117 19.8306 190.733 15.7658C190.348 11.701 188.937 7.7962 187.397 4.01945C186.98 2.99525 186.243 2.2271 185.056 2.2271C184.864 2.2271 183.036 2.70719 183.164 2.93123Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    d: "M173.158 135.725C173.479 136.685 175.403 137.069 176.814 137.229C178.225 137.357 182.362 136.493 183.805 135.053C185.216 133.644 185.024 129.932 184.832 127.211C184.639 124.522 184.832 121.258 184.832 121.258L184.222 121.322L175.948 122.09C175.82 123.53 175.499 125.003 175.146 126.411C174.826 127.691 174.409 128.907 174.024 129.996C173.126 132.268 172.805 134.765 173.158 135.725Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_65_",
    d: "M174.857 130.507C174.921 130.987 175.723 131.915 178.994 131.915C182.233 131.883 184.606 131.179 184.286 128.074C184.061 125.962 184.125 122.985 184.222 121.289L175.947 122.057C175.819 123.498 175.498 124.97 175.146 126.378C175.017 128.426 174.825 130.283 174.857 130.507Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_64_",
    d: "M156.513 135.725C156.833 136.685 158.758 137.069 160.169 137.229C161.58 137.357 165.717 136.493 167.16 135.053C168.571 133.644 168.379 129.932 168.186 127.211C167.994 124.522 168.186 121.258 168.186 121.258L167.577 121.322L159.303 122.09C159.175 123.53 158.854 125.003 158.501 126.411C158.18 127.691 157.763 128.907 157.379 129.996C156.449 132.268 156.16 134.765 156.513 135.725Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    d: "M158.181 130.507C158.245 130.987 159.047 131.915 162.318 131.915C165.557 131.883 167.93 131.179 167.61 128.074C167.385 125.962 167.449 122.985 167.545 121.289L159.271 122.057C159.143 123.498 158.822 124.97 158.469 126.378C158.373 128.426 158.149 130.283 158.181 130.507Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    d: "M159.271 39.2897H167.674L169.534 28.5996C169.694 28.5996 167.674 26.0391 167.674 26.0391C167.674 26.0391 160.811 28.6636 159.271 39.2897Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    d: "M164.273 39.2897H167.673L169.533 28.5996C169.693 28.5996 167.673 26.0391 167.673 26.0391C167.673 26.0391 165.909 27.5754 164.69 31.9922C164.016 34.3927 164.081 37.2413 164.273 39.2897Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    d: "M159.977 71.1354C168.507 75.3282 197.467 70.0152 197.467 70.0152C197.467 70.0152 196.922 67.7747 196.312 64.9902C195.671 61.9495 194.965 58.3008 194.901 56.3164C194.773 52.5397 195.446 47.6427 194.773 40.8894C194.099 34.232 197.371 27.2867 197.467 27.0946C193.715 23.2218 187.461 22.2617 187.461 22.2617C187.461 22.2617 179.604 22.0056 176.493 22.8058C173.382 23.6059 167.673 26.0384 167.673 26.0384C167.673 26.0384 167.257 26.7105 167 27.3827C165.621 30.8074 165.364 38.2008 166.455 41.7855C167.545 45.3702 167.128 58.2048 165.781 60.1252C164.402 62.0136 159.977 71.1354 159.977 71.1354Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    d: "M176.781 22.6458C176.685 22.6458 175.755 22.7098 174.729 23.3499C173.67 23.9901 175.755 29.8472 177.743 31.4155C179.732 32.9839 184.67 25.9104 184.991 24.5982C185.312 23.2859 184.606 22.2617 184.606 22.2617L181.56 22.2937L176.781 22.6458Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    d: "M184.221 24.7578L181.335 28.6625L179.314 28.7586L176.043 25.1418L176.364 20.6609L176.588 17.9724L183.002 17.6523L183.74 21.8452L184.221 24.7578Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_57_",
    d: "M183.741 21.8452C180.309 22.4853 177.872 21.5891 176.396 20.6609L176.589 17.9724L183.035 17.6523L183.741 21.8452Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    d: "M186.562 11.6677V11.8277C186.627 13.396 186.402 14.9003 185.889 16.2126C184.831 18.9651 182.682 20.9175 180.052 21.1095C177.262 21.2696 174.728 19.3812 173.414 16.5006C173.349 16.3726 173.317 16.2446 173.253 16.1486C172.868 15.2204 172.612 14.1962 172.484 13.108C172.451 12.9479 172.451 12.7559 172.419 12.5959C172.259 9.90732 173.029 7.41082 174.408 5.68248C174.408 5.65047 174.472 5.61847 174.472 5.58646C175.626 4.17818 177.166 3.282 178.898 3.15398C180.726 3.02595 182.489 3.82611 183.836 5.23439C184.157 5.55445 184.414 5.87452 184.67 6.25859C185.28 7.12276 185.761 8.11496 186.081 9.23519C186.37 9.97133 186.498 10.8035 186.562 11.6677Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    d: "M186.562 11.6701V11.8301C184.863 11.638 183.259 10.7739 182.233 9.3976C181.207 11.446 179.122 12.7583 177.166 13.9105C176.396 14.3586 175.626 14.8067 174.889 15.3188C174.472 15.6068 173.959 16.1509 173.446 16.439C172.965 15.4148 172.644 14.2626 172.516 13.0463C173.285 12.2142 174.344 11.7021 175.145 10.9659C176.653 9.58964 177.294 7.44521 178.898 6.19697C179.86 5.46082 181.11 5.10875 182.297 5.23677C183.163 5.33279 183.997 5.68486 184.702 6.19697C185.312 7.06114 185.793 8.05334 186.113 9.17356C186.37 9.97372 186.498 10.8059 186.562 11.6701Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    d: "M184.382 10.8684C185.12 11.6366 185.986 12.2127 186.723 12.9809C186.788 13.0769 186.884 13.1409 187.012 13.1729C187.237 13.2369 187.493 13.0769 187.621 12.8848C187.91 12.4688 187.91 11.9247 187.878 11.4126C187.718 9.49217 187.525 7.47577 186.659 5.68341C186.467 5.26733 186.242 4.88325 185.986 4.56319C185.665 4.17911 185.28 3.89106 184.863 3.66701C184.543 3.18692 183.837 2.83484 183.099 2.41876C182.683 2.19472 182.266 1.97067 181.817 1.93867C181.304 1.87465 180.79 2.06669 180.245 2.06669C179.828 2.06669 179.443 1.93867 179.027 1.87465C178.321 1.74663 177.551 1.81064 177.006 2.25873C176.814 2.41876 176.653 2.6108 176.493 2.80284C175.691 3.57099 174.28 3.73102 173.735 4.69121C173.575 4.97927 173.51 5.29934 173.382 5.58739C173.19 5.97147 172.869 6.25953 172.58 6.57959C172.035 7.18771 171.522 7.92386 171.554 8.69201C171.586 9.07609 171.747 9.42816 171.779 9.81223C171.875 10.4524 171.618 11.0605 171.65 11.7006C171.682 12.3087 172.035 12.6928 172.26 13.2369C172.709 14.3891 172.612 15.5414 173.286 16.6616C174.473 14.4532 176.846 13.0129 178.353 10.9965C178.994 10.1323 181.143 5.6514 182.715 7.37975C183.099 7.79583 183.196 8.37195 183.356 8.91606C183.548 9.6202 183.869 10.3563 184.382 10.8684Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    d: "M187.974 59.4873C188.872 60.3835 193.523 63.2961 196.345 65.0245C195.703 61.9838 194.998 58.3351 194.934 56.3507C194.805 52.574 195.479 47.677 194.805 40.9237C194.132 34.2663 197.403 27.3209 197.499 27.1289C197.307 27.2889 194.196 29.9455 192.849 35.7386C191.47 41.7238 192.849 47.517 192.849 47.517L189.321 46.5568C189.321 46.5568 187.076 48.0291 186.692 51.4858C186.243 54.9104 186.66 58.1751 187.974 59.4873Z",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    d: "M193.49 51.5176C193.49 51.5176 191.277 49.2132 190.572 48.605C189.834 47.9969 189.032 48.9571 188.68 50.6854C188.327 52.3818 187.301 56.7987 188.68 57.5348C190.059 58.271 192.528 58.1749 192.528 58.1749L193.49 51.5176Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    d: "M157.7 49.918C157.7 49.918 157.155 54.975 158.47 56.2552C159.785 57.5355 162.799 59.4239 163.665 59.4879C164.531 59.5519 166.968 59.8399 167.962 57.0234L164.531 52.4145L157.7 49.918Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    d: "M175.659 37.2734L182.778 48.1556L188.679 57.5335H166.519L152.889 37.2734H175.659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    d: "M176.973 51.8041C177.101 52.0602 177.39 52.1882 177.679 52.2522C177.967 52.3162 178.256 52.3162 178.513 52.4122C178.192 52.6043 178.224 53.1164 178.513 53.3724C178.769 53.6285 179.186 53.6925 179.539 53.7565C179.988 53.8205 180.469 53.9165 180.95 53.9805C180.725 54.1086 180.661 54.4606 180.822 54.6847C180.95 54.8447 181.142 54.9087 181.303 54.9727C182.072 55.2288 182.81 55.4848 183.58 55.7729C184.221 55.997 184.895 56.221 185.504 56.029C185.889 55.9009 186.242 55.6449 186.626 55.4848C187.075 55.2608 187.588 55.1968 188.102 55.2608L188.679 55.5489L191.597 57.0852C191.597 57.0852 193.682 54.6847 192.463 50.7159C192.463 50.7159 190.411 49.8517 188.807 49.0516C188.166 48.7315 187.621 48.4114 187.268 48.1874C186.049 47.3552 184.734 46.7151 183.708 46.5871C182.682 46.427 181.88 46.043 181.367 46.043L182.778 48.1874C182.778 48.1874 179.411 48.6035 178.513 49.0516C177.743 49.4356 178.32 50.1078 178.416 50.6519C178.032 50.6839 177.647 50.7159 177.358 50.9079C177.005 51.068 176.813 51.484 176.973 51.8041Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    opacity: 0.7,
    d: "M188.646 55.5168L191.565 57.0531C191.565 57.0531 193.649 54.6526 192.431 50.6839C192.431 50.6839 190.378 49.8197 188.775 49.0195C189.031 50.4278 189.192 52.7323 188.646 55.5168Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    d: "M197.467 27.1289C197.467 27.1289 202.085 30.2655 203.304 38.3631C204.394 45.5006 201.412 59.0393 200.065 61.0877C198.686 63.1041 188.68 57.567 188.68 57.567C188.68 57.567 191.919 53.6302 190.572 48.6372L194.516 50.2055C194.484 50.1735 191.63 35.9627 197.467 27.1289Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_46_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M200.449 53.2116C200.385 53.2116 200.353 53.1796 200.289 53.1475C200.257 53.1155 198.076 51.2272 194.42 50.395C194.324 50.363 194.26 50.299 194.26 50.171C194.26 50.0749 194.324 49.9789 194.42 49.9469C194.516 49.9149 196.505 49.3708 199.455 49.9469C199.583 49.9789 199.648 50.0749 199.616 50.203C199.583 50.331 199.487 50.395 199.359 50.363C197.691 50.0429 196.344 50.0749 195.478 50.203C198.653 51.1311 200.481 52.7315 200.546 52.7955C200.642 52.8915 200.642 53.0195 200.578 53.1155C200.578 53.1795 200.513 53.2116 200.449 53.2116Z",
    fill: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    d: "M183.9 50.0781C183.9 50.0781 180.308 50.3982 178.416 50.5902",
    stroke: "#A3A3A3",
    strokeWidth: 1.381,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    d: "M183.901 52.3164C183.901 52.3164 179.348 52.5405 178.514 52.3804",
    stroke: "#A3A3A3",
    strokeWidth: 1.381,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    d: "M183.901 54.076C183.901 54.076 181.912 53.884 180.918 53.98",
    stroke: "#A3A3A3",
    strokeWidth: 1.381,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    d: "M163.76 54.4944C163.76 54.4944 162.157 56.1267 160.521 55.7747C158.853 55.4226 158.116 53.6942 158.02 52.446C157.923 51.1977 157.667 50.9737 157.314 50.0775C156.929 49.2133 157.25 48.3172 157.186 47.0689C157.122 45.8207 157.154 43.8683 158.052 43.4202C158.982 42.9721 159.27 44.9565 159.27 44.9565C159.27 44.9565 160.874 42.716 161.996 42.556C163.119 42.396 163.44 43.7403 162.574 44.8285C161.708 45.9167 160.906 46.3968 160.681 46.8129C160.457 47.261 160.682 48.1251 161.098 47.9971C161.515 47.8691 164.594 45.3406 165.588 44.7965C166.615 44.2524 167.512 44.2844 167.994 44.8925C168.475 45.5006 167.994 46.1087 167.994 46.1087C167.994 46.1087 168.988 45.7246 169.565 46.0127C170.142 46.3328 169.565 47.613 169.565 47.613C169.565 47.613 170.174 47.8051 170.271 48.4772C170.367 49.2133 169.18 49.2133 168.635 49.7574C168.09 50.3016 166.262 51.6778 165.652 52.478C165.011 53.2781 163.76 54.4944 163.76 54.4944Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    d: "M159.271 44.957C159.271 44.957 158.084 46.2693 157.699 47.4215",
    stroke: "#A3A3A3",
    strokeWidth: 1.381,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    d: "M167.962 46.0742C167.962 46.0742 163.664 48.8908 162.734 50.075",
    stroke: "#A3A3A3",
    strokeWidth: 1.381,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    d: "M169.534 47.582C169.534 47.582 165.365 49.7585 164.242 51.5188",
    stroke: "#A3A3A3",
    strokeWidth: 1.381,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    d: "M156.352 101.383C156.641 106.568 156.641 122.572 156.641 122.572C156.641 122.572 165.011 124.716 169.533 122.059C169.533 122.059 169.084 113.322 169.533 107.369C169.63 106.184 169.79 104.776 169.982 103.24C170.816 97.0305 172.323 89.1249 172.323 89.1249L179.026 72.3856C179.026 72.3856 177.487 71.3613 175.017 70.4012C171.65 69.0889 166.551 68.0007 161.548 70.0491C152.889 73.5698 156.064 96.1983 156.352 101.383Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    opacity: 0.5,
    d: "M169.982 103.241C170.815 97.0316 172.323 89.1261 172.323 89.1261L179.025 72.3867C179.025 72.3867 177.486 71.3625 175.017 70.4023C172.676 71.6826 170.366 74.1151 169.533 78.564C168.378 84.7092 169.18 95.5914 169.982 103.241Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    d: "M198.621 69.4082C198.621 69.4082 195.767 66.6877 191.405 67.1358C187.043 67.5839 177.583 67.7759 173.221 74.4652C168.86 81.1546 172.291 104.679 172.419 109.768C172.516 114.825 172.516 122.859 172.516 122.859C172.516 122.859 180.437 123.787 186.498 122.859C186.498 122.859 187.973 86.3396 187.557 84.4192C187.557 84.4192 195.189 83.6191 198.011 80.3544C200.866 77.1218 198.621 69.4082 198.621 69.4082Z",
    fill: "#616161"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M95.1623 59.8086H92.7891V85.5417H95.1623V59.8086Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M124.731 59.8086H122.357V85.5417H124.731V59.8086Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M126.045 74.9152H91.5055C88.4588 74.9152 86.0215 72.4507 86.0215 69.4421V46.2055C86.0215 40.6684 90.5113 36.1875 96.0595 36.1875H121.555C127.104 36.1875 131.593 40.6684 131.593 46.2055V69.4421C131.529 72.4507 129.092 74.9152 126.045 74.9152Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M132.843 123.885H135.12L130.246 81.3164H127.969L132.843 123.885Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M84.7056 123.885H82.3965L87.3032 81.3164H89.5802L84.7056 123.885Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M86.919 72.6758H85.123V83.622H86.919V72.6758Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M89.8056 73.154H82.2049C80.858 73.154 79.7676 72.0658 79.7676 70.7215C79.7676 69.3773 80.858 68.2891 82.2049 68.2891H89.8056C91.1526 68.2891 92.243 69.3773 92.243 70.7215C92.243 72.0658 91.1526 73.154 89.8056 73.154Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M132.46 72.6758H130.664V83.622H132.46V72.6758Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M135.345 73.154H127.744C126.397 73.154 125.307 72.0658 125.307 70.7215C125.307 69.3773 126.397 68.2891 127.744 68.2891H135.345C136.692 68.2891 137.782 69.3773 137.782 70.7215C137.782 72.0658 136.692 73.154 135.345 73.154Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M135.12 90.3408H82.3965V87.6523C82.3965 83.7155 85.5715 80.5469 89.5161 80.5469H128.001C131.945 80.5469 135.12 83.7155 135.12 87.6523V90.3408Z",
    fill: "#C3C3C3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M24.672 59.8086H22.2988V85.5417H24.672V59.8086Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M54.2404 59.8086H51.8672V85.5417H54.2404V59.8086Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M55.5539 74.9152H20.9821C17.9354 74.9152 15.498 72.4507 15.498 69.4421V46.2055C15.498 40.6684 19.9879 36.1875 25.5361 36.1875H51.032C56.5802 36.1875 61.07 40.6684 61.07 46.2055V69.4421C61.038 72.4507 58.6006 74.9152 55.5539 74.9152Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M62.354 123.885H64.631L59.7563 81.3164H57.4473L62.354 123.885Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M14.2153 123.885H11.9062L16.813 81.3164H19.09L14.2153 123.885Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M16.4288 72.6758H14.6328V83.622H16.4288V72.6758Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M19.3154 73.154H11.7147C10.3677 73.154 9.27734 72.0658 9.27734 70.7215C9.27734 69.3773 10.3677 68.2891 11.7147 68.2891H19.3154C20.6623 68.2891 21.7527 69.3773 21.7527 70.7215C21.7527 72.0658 20.6623 73.154 19.3154 73.154Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M61.9698 72.6758H60.1738V83.622H61.9698V72.6758Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M64.8544 73.154H57.2538C55.9068 73.154 54.8164 72.0658 54.8164 70.7215C54.8164 69.3773 55.9068 68.2891 57.2538 68.2891H64.8544C66.2014 68.2891 67.2918 69.3773 67.2918 70.7215C67.2918 72.0658 66.2014 73.154 64.8544 73.154Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M64.6299 90.3408H11.9062V87.6523C11.9062 83.7155 15.0812 80.5469 19.0259 80.5469H57.5103C61.455 80.5469 64.6299 83.7155 64.6299 87.6523V90.3408Z",
    fill: "#C3C3C3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataFound);
export default __webpack_public_path__ + "static/media/nodata-found.04f22267d87b3987285f058c57bc2318.svg";
export { ForwardRef as ReactComponent };